<template>
<section class="layerPop fullType" style="display:block; z-index:9998">
  <div class="popWrap">

    <h1 class="popTit tac">
      <slot name="title"></slot>
    </h1>

    <div class="popCon" style="height: calc(100vh - 95px);">
      <div class="contArea tpd10">
        <slot name="content"></slot>
      </div>
    </div>

    <div class="btnBox btnBoxCustom">
      <slot name="button"></slot>
    </div>

    <button type="button" class="btnClose" @click="close">닫기</button>
  
  </div>
	</section>
</template>


<script>
export default {
  mounted() {
    if(this.$el['style'].display !== 'none'){
      let $this = this;
      this.$store.commit('openPopup', {
        name: 'popupFull',
        onClosed: ()=>$this.$emit('close', true),
      })
    }
  },

  destroyed() {
    this.$store.commit('closePopup', {name: 'popupFull'})
  },

  methods: {
    close(){
      this.$emit('close');
    }
  }
}
</script>

<style lang="css" scoped>
.btnBoxCustom {
  margin-left:0px !important;
}
</style>